import * as React from 'react';
import type { SVGProps } from 'react';

// Make the fill prop customizable, defaulting to '#616061' if not provided.
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => {
  const { fill, ...restProps } = props;
  const iconFill = fill || '#616061';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...restProps}>
      <path fill={iconFill} d="M6 .5H3v2H1v3h14v-3h-2v-2h-3v2H6zM15 7.5H1v8h14z" />
    </svg>
  );
};

export default SvgCalendar;
